// NotFoundPage — catch-all 404. Intentionally minimal: a heading,
// a friendly line, and a link back to Discover. Sits outside the
// AppLayout so it renders bare regardless of where the user got
// here from.

import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 12,
        color: 'var(--text-md)',
        fontFamily: 'var(--font-sans)',
      }}
    >
      <h1 style={{ fontSize: 28, margin: 0, color: 'var(--text-hi)' }}>Not found</h1>
      <p style={{ margin: 0 }}>That route doesn't exist (yet).</p>
      <Link
        to="/discover"
        style={{
          marginTop: 12,
          padding: '8px 16px',
          background: 'var(--accent)',
          color: '#fff',
          borderRadius: 'var(--radius-sm)',
        }}
      >
        Go to Discover
      </Link>
    </div>
  )
}
